/** Shared typography tokens — keep in sync with website/src/theme/typography.js */
export const FONT_BODY =
  '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const FONT_DISPLAY =
  '"Plus Jakarta Sans", "Inter", system-ui, -apple-system, sans-serif';

export const typography = {
  fontFamily: FONT_BODY,
  fontSize: 16,
  htmlFontSize: 16,
  fontWeightLight: 400,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 800,
    letterSpacing: '-0.03em',
    lineHeight: 1.08,
    fontSize: 'clamp(2rem, 4vw, 3rem)',
  },
  h2: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 800,
    letterSpacing: '-0.025em',
    lineHeight: 1.12,
    fontSize: 'clamp(1.625rem, 3vw, 2.375rem)',
  },
  h3: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 700,
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
    fontSize: 'clamp(1.375rem, 2.5vw, 1.875rem)',
  },
  h4: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 700,
    letterSpacing: '-0.015em',
    lineHeight: 1.25,
    fontSize: '1.25rem',
  },
  h5: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    lineHeight: 1.35,
    fontSize: '1.125rem',
  },
  h6: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    lineHeight: 1.4,
    fontSize: '1rem',
  },
  subtitle1: {
    fontFamily: FONT_BODY,
    fontWeight: 500,
    fontSize: '1.0625rem',
    lineHeight: 1.65,
    letterSpacing: '-0.01em',
  },
  subtitle2: {
    fontFamily: FONT_BODY,
    fontWeight: 600,
    fontSize: '0.9375rem',
    lineHeight: 1.55,
    letterSpacing: '0.01em',
  },
  body1: {
    fontFamily: FONT_BODY,
    fontSize: '1rem',
    lineHeight: 1.7,
    letterSpacing: '-0.011em',
  },
  body2: {
    fontFamily: FONT_BODY,
    fontSize: '0.9375rem',
    lineHeight: 1.65,
    letterSpacing: '-0.006em',
  },
  button: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    textTransform: 'none',
    fontSize: '0.9375rem',
  },
  caption: {
    fontFamily: FONT_BODY,
    fontSize: '0.8125rem',
    lineHeight: 1.55,
    letterSpacing: '0.01em',
  },
  overline: {
    fontFamily: FONT_DISPLAY,
    fontWeight: 800,
    fontSize: '0.6875rem',
    lineHeight: 1.5,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
  },
};

export const typographyComponents = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility',
      },
      body: {
        fontFamily: FONT_BODY,
        fontSize: '1rem',
        lineHeight: 1.7,
        letterSpacing: '-0.011em',
      },
      'h1, h2, h3, h4, h5, h6': {
        fontFamily: FONT_DISPLAY,
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        fontFeatureSettings: '"cv02", "cv03", "cv04", "cv11"',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontFamily: FONT_BODY,
        fontWeight: 500,
        fontSize: '0.9375rem',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        fontFamily: FONT_BODY,
        fontSize: '0.9375rem',
        fontWeight: 500,
        letterSpacing: '-0.01em',
      },
    },
  },
};
